import { Button, createStyles } from '@mantine/core'

import { Tile } from '../../components/tile'
import { AngularStyle } from '../../components/angular-style'
import { Splash, SplashTitle } from '../../components/splash'
import img1 from '../../assets/large_mof_background.svg'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'

const useStyles = createStyles((theme) => ({
  splashText: {
    h1: {
      [theme.fn.smallerThan('sm')]: {
        fontSize: `${theme.fontSizes.lg * 2}px !important`,
      },
    },
    justifyContent: 'start',
    height: '100%',
  },

  text: {
    padding: '2em 8em',
    [theme.fn.smallerThan('lg')]: {
      padding: '1em 1.5em',

      [theme.fn.smallerThan('sm')]: {
        padding: theme.spacing.sm,
      },
    },
  },
}))

export function WeightGainTraining() {
  const { classes } = useStyles()

  return (
    <main>
      <Helmet>
        <title>Weight Gain Coaching Coventry | Mistry Of Fitness</title>
        <meta
          name='description'
          content='Weight gain coaching in Coventry ✓ | Custom muscle building & nutrition plans | Transform from skinny to strong | Start your free consultation →'
        />
      </Helmet>

      <Splash height={'calc(100vh - 56px)'} backgroundSrc={`url(${img1})`}>
        <div className={classes.splashText}>
          <SplashTitle>Weight Gain Coaching in Coventry</SplashTitle>
        </div>
      </Splash>

      <div className='about-tile'>
        <Tile tileOpts={{ colour: 'bg-black', accent: 'bg-black', style: 'simple-3' }} mh={200}>
          <p className={classes.text}>
            Are you tired of being the “skinny guy” struggling to gain muscle no matter how much you
            eat? My specialist weight gain coaching in Coventry is designed to help you go from
            skinny to strong with a proven, science-backed approach.
          </p>
        </Tile>
        <Tile
          tileOpts={{ colour: 'bg-primary', accent: 'brand-primary', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>Why Choose My Weight Gain Coaching?</h2>
            <p>
              Gaining weight healthily isn’t just about eating more. It requires a precise balance
              of nutrition, training, and recovery tailored specifically to your metabolism and
              lifestyle. I specialise in helping ‘hard gainers’ like you build lean muscle, increase
              strength, and improve overall fitness through structured guidance and accountability.
            </p>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'brand-secondary', accent: 'bg-tertiary', style: 'simple-3' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>Expertise You Can Trust</h2>
            <p>
              My weight gain coaching program is built on years of fitness and nutrition experience.
              I focus on educating you on the principles of muscle hypertrophy, calorie surplus, and
              recovery strategies, ensuring you gain weight in a sustainable, healthy way without
              unnecessary fat.
            </p>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'bg-tertiary', accent: 'brand-primary', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>What’s Included in My Weight Gain Coaching Program?</h2>
            <ul>
              <li>
                <strong>Initial Assessment:</strong> I analyse your body composition, metabolism,
                and lifestyle.
              </li>
              <li>
                <strong>Customised Nutrition Plan:</strong> Tailored meal plans designed to deliver
                the right calories and macros for muscle growth.
              </li>
              <li>
                <strong>Strength Training Program:</strong> Focused workouts targeting all major
                muscle groups to maximise hypertrophy.
              </li>
              <li>
                <strong>Progress Tracking & Adjustments:</strong> Regular check-ins to ensure
                continual progress and tweak your plan.
              </li>
            </ul>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'brand-tertiary', accent: 'bg-primary', style: 'simple-2' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>Why Local Expertise Matters</h2>
            <p>
              Choosing a weight gain coach near me in Coventry means you get hands-on, personalised
              support from someone who understands the local lifestyle and resources. I train at
              Simply Gym Coventry, providing a private, professional environment designed for your
              success.
            </p>
            <br />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Link to='/services' style={{ margin: '1.2em' }}>
                <Button
                  variant='light'
                  radius='xl'
                  size='lg'
                  styles={{ root: { padding: '0 14', height: 48 } }}
                >
                  View My Other Training Options
                </Button>
              </Link>
            </div>
          </div>
        </Tile>
        <Tile tileOpts={{ colour: 'bg-primary', accent: 'bg-primary', style: 'simple-3' }} mh={200}>
          <div className={classes.text}>
            <h2>Real Results for Coventry Clients</h2>
            <p>
              My clients regularly share their transformation stories, moving from struggling to
              gain weight to building strong, muscular physiques. With personalised coaching and
              expert support, I help you overcome plateaus and stay consistent.
            </p>
            <br />
            <Link to='/testimonials' style={{ margin: '1.2em' }}>
              <Button
                variant='filled'
                radius='xl'
                size='md'
                styles={{ root: { padding: '0 14', height: 48 } }}
              >
                Read Reviews
              </Button>
            </Link>
          </div>
        </Tile>
        <Tile
          tileOpts={{ colour: 'brand-primary', accent: 'bg-black', style: 'simple-1' }}
          mh={200}
        >
          <div className={classes.text}>
            <h2>Start Your Skinny to Strong Journey Now</h2>
            <p>
              Don’t let genetics or a fast metabolism hold you back. Take the first step towards a
              healthier, stronger you by booking a free consultation with me. Contact me today and
              start your muscle-building transformation with Coventry’s trusted weight gain coach!
            </p>
            <a
              href='/contact-faqs'
              style={{ color: '#007bff', textDecoration: 'underline', fontWeight: 'bold' }}
            >
              Contact Rik to secure your spot with one of Coventry’s leading personal trainers!
            </a>
          </div>
          <div className={classes.text}>
            <iframe
              title='Personal Training Coventry Location'
              src='https://www.google.com/maps?q=Simply+Gym,+Earl+Place+Business+Park,+Fletchamstead+Highway,+Coventry+CV4+9XL&output=embed'
              width='100%'
              height='350'
              style={{ border: 0 }}
              allowFullScreen={true}
              loading='lazy'
              referrerPolicy='no-referrer-when-downgrade'
            ></iframe>
          </div>
        </Tile>
      </div>

      <AngularStyle
        className='test'
        colour='brand-secondary'
        style={3}
        side={'right'}
        size={'sm'}
        height={'50px'}
        width={'100%'}
      ></AngularStyle>
    </main>
  )
}
